var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_1323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H0V49H52V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5754 28.0024H7.36844V30.6929C7.36844 31.3391 7.92978 31.8659 8.61208 31.8659H28.8213C28.8213 30.1744 28.8213 29.3137 27.4481 29.3137L24.7131 29.3111C22.9915 29.3084 21.8629 28.8929 21.2324 28.0024H13.5754Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3846 31.8659H8.61287C7.57074 33.5763 6.73295 35.6316 7.45547 39.563C8.66467 35.6859 20.9462 37.2335 22.2072 41.7078H35.7584C36.2709 40.6136 36.7545 39.533 37.1777 38.4416H33.3574C25.6303 35.694 28.1148 36.9185 26.3846 31.8659Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4811 21.356C27.2162 22.67 26.8564 23.9651 26.4533 25.0674L22.5468 26.5098L18.1908 25.0674C18.3433 17.2997 21.4238 13.5747 24.0436 12.3693C24.9879 11.6918 25.9552 11.4366 25.9552 11.4366C25.9552 11.4366 27.2277 13.3548 27.2939 13.3548C27.7834 14.4517 27.9677 15.8825 27.936 17.4274L27.4811 21.356Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1912 25.0674H26.4537C28.3567 25.2629 30.6973 26.6285 30.6973 30.8586V35.2922H26.3846V31.8659C26.3846 30.1744 26.3846 29.3137 25.0113 29.3137L22.2764 29.3111C20.5547 29.3083 19.4262 28.8929 18.7957 28.0024C18.3092 27.3155 18.122 26.3462 18.1912 25.0674Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1915 25.0674C18.344 17.2997 21.4245 13.5747 24.0443 12.3692C24.433 12.6272 24.8648 12.839 25.3398 12.9965C23.0194 14.6498 20.6933 18.345 20.5608 25.0674H18.1915Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1909 25.0674H20.5603C20.4911 26.3462 20.6783 27.3155 21.1648 28.0024C21.5621 28.5644 22.161 29.0395 22.9814 29.3111H22.2762C20.5545 29.3083 19.4259 28.8929 18.7954 28.0024C18.309 27.3155 18.1218 26.3462 18.1909 25.0674Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4811 21.356C27.2162 22.67 26.8564 23.9651 26.4533 25.0674H18.1908C18.3433 17.2997 21.4238 13.5747 24.0436 12.3693M27.2939 13.3548C27.7834 14.4517 27.9677 15.8825 27.936 17.4274",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5752 21.9234H0.760952V26.1181C0.760952 27.1553 1.65917 28.0024 2.75899 28.0024H7.3682L10.1175 29.311L13.5752 28.0024V21.9234Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5772 15.8363H2.75899C1.65917 15.8363 0.760952 16.6835 0.760952 17.7205V20.8374H13.5752V17.7205C13.5752 16.6835 12.6769 15.8363 11.5772 15.8363Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5762 19.898H0.76193V22.8601H13.5762V19.898Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43555 19.898H1.79461H0.761007V17.7206C0.761007 17.012 1.18137 16.3929 1.79461 16.0726C2.08244 15.9233 2.41059 15.8364 2.75905 15.8364H5.43359C4.33377 15.8364 3.43555 16.6835 3.43555 17.7206V19.898Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43652 22.8601H1.79558H0.761976V21.9234V20.8374V19.898H1.79558H3.43652V20.8374V21.9234V22.8601Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43555 22.8601V26.1182C3.43555 27.1553 4.33377 28.0024 5.43359 28.0024H2.75905C2.41059 28.0024 2.08244 27.9182 1.79461 27.7688C1.18137 27.4458 0.761007 26.8267 0.761007 26.1182V22.8601H1.79461H3.43555Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5752 28.0024H2.75899C1.65917 28.0024 0.760952 27.1553 0.760952 26.1182V17.7206C0.760952 16.6835 1.65917 15.8363 2.75899 15.8363H11.5772C12.6769 15.8363 13.5752 16.6835 13.5752 17.7206V28.0024Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5762 22.8601H0.76193V19.898H13.5762V22.8601Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.207 41.7078C22.207 37.6923 18.8301 34.494 14.6642 34.494C11.2757 34.494 8.40824 36.6117 7.45528 39.563C7.25957 40.1684 7.1444 40.8119 7.12419 41.4797C7.11555 41.7404 7.30558 41.7078 7.56466 41.7078C12.4445 41.7078 17.3273 41.7051 22.207 41.7078Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3096 41.7078H8.82833C8.99246 44.6238 11.5 46.9424 14.5691 46.9424C17.6379 46.9424 20.1455 44.6238 20.3096 41.7078Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4645 40.5539L39.5868 42.6961C40.2144 45.2672 42.935 46.8745 45.6614 46.2826C48.3907 45.6908 50.0921 43.1251 49.4645 40.5539Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2048 37.9448C48.8085 36.0307 46.3844 34.9202 43.8509 35.1593C39.3828 36.0497 37.9289 38.5665 37.6381 41.7051C37.6439 42.1313 37.6929 42.5604 37.7908 42.9893C37.8195 43.1088 37.903 43.0598 38.0413 43.0301L39.5872 42.6961L49.4649 40.554L50.2048 40.3937L51.2383 40.1684C51.0396 39.3485 50.6827 38.5991 50.2048 37.9448Z",
    fill: "#ECEAEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8594 35.1483L39.8692 22.1379L38.0726 21.3804L36.0632 22.1379C38.7031 29.0341 37.9662 33.8478 36.1841 38.4416C35.758 39.533 35.2744 40.6136 34.7649 41.7078H37.6351L43.8594 35.1483Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5025 7.55007L26.8213 6.61074C26.3463 6.65142 24.9875 7.72664 24.9875 8.39991L25.9836 13.1729C26.3981 13.2897 26.8387 13.3548 27.2935 13.3548C29.7866 13.3548 31.8076 11.4461 31.8076 9.09501C31.8076 8.54921 31.7012 8.02792 31.5025 7.55007Z",
    fill: "#FFECE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0156 7.55007C33.0156 4.51466 30.4649 2.05758 27.3153 2.05758C24.1657 2.05758 21.615 4.51466 21.615 7.55007C21.615 9.55381 22.4787 11.3348 24.0448 12.3692C24.6033 12.7412 25.254 13.0154 25.9853 13.1729V8.39992C25.9853 7.72665 26.3479 7.59084 26.823 7.55007H31.5042H33.0156Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2979 2.8694C29.4313 2.35347 28.4093 2.05765 27.3153 2.05765C24.1657 2.05765 21.615 4.51464 21.615 7.55005C21.615 9.55379 22.4787 11.3348 24.0448 12.3693C24.4421 12.6327 24.8825 12.8471 25.3663 13.0046C24.2089 11.8996 23.5813 10.314 23.5813 8.56556C23.5813 5.39443 26.2501 2.82327 29.5407 2.82327C29.7969 2.82327 30.0502 2.83677 30.2979 2.8694Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6966 35.2922H26.3839V37.8525C26.3839 38.4008 26.7006 38.4416 27.167 38.4416H33.3567C33.4805 35.8732 31.8308 35.2922 30.6966 35.2922Z",
    fill: "#6F6571"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1849 38.4416C37.9669 33.8478 38.7039 29.0341 36.064 22.1379H37.5437H37.561H38.0936C40.7336 29.0341 39.9994 33.8478 38.2145 38.4416C37.7913 39.533 37.3076 40.6136 36.7951 41.7078H35.7588H34.7655C35.2751 40.6136 35.7588 39.533 36.1849 38.4416Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.639 41.7051L43.8518 35.1593C44.4937 35.0995 45.13 35.1239 45.7432 35.2298L39.7723 41.5205C39.7781 41.887 39.8155 42.259 39.8903 42.6309L39.5881 42.6961L38.0421 43.0301C37.9039 43.0598 37.8204 43.1088 37.7915 42.9893C37.6937 42.5604 37.6448 42.1313 37.639 41.7051Z",
    fill: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61208 31.8659H26.3838V33.3401H11.7818C10.5928 33.3401 10.0285 33.8234 9.56504 34.8035C9.16478 35.6533 9.15615 35.9303 8.97486 36.9565C8.29256 37.7032 7.7685 38.5883 7.45467 39.563C6.73215 35.6316 7.56994 33.5763 8.61208 31.8659Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97515 36.9565C10.357 35.4442 12.3924 34.494 14.664 34.494C15.2339 34.494 15.7866 34.5537 16.3193 34.6651C12.9192 35.39 10.5412 38.219 10.4375 41.4798C10.4319 41.659 10.5182 41.6997 10.6564 41.7078H8.82829H7.56434C7.30536 41.7078 7.11534 41.7404 7.12387 41.4798C7.14418 40.8118 7.25925 40.1684 7.45496 39.5629C7.46085 39.544 7.46654 39.5276 7.47233 39.5113V39.5087C7.789 38.5556 8.30433 37.6895 8.97515 36.9565Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8886 42.6309L49.464 40.5539C49.5706 40.9802 49.608 41.4091 49.5907 41.8274L41.9903 43.4753L41.6909 43.5404C41.973 44.7079 42.6898 45.6772 43.6428 46.3315C41.6995 46.0084 40.0556 44.6237 39.5864 42.6961L39.8886 42.6309Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6565 41.7078H20.3096C20.2779 42.278 20.1542 42.8263 19.9555 43.3396H13.2303H11.4021C11.4741 44.6156 11.9923 45.7749 12.8099 46.679C10.5903 45.9921 8.95783 44.04 8.82833 41.7078H10.6565Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37 30.6929V28.0024H11.2709V30.6929C11.2709 31.3391 11.8324 31.8659 12.5146 31.8659H8.61363C7.93134 31.8659 7.37 31.3391 7.37 30.6929Z",
    fill: "#5D5360"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7861 8.6388H27.9399C27.4649 8.67957 27.1021 8.81805 27.1021 9.49132V13.3494C26.7163 13.3331 26.342 13.2734 25.9851 13.1729V8.39992C25.9851 7.72665 26.3478 7.59085 26.8228 7.55008H31.504C31.6451 7.89222 31.743 8.25867 31.7861 8.6388Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3153 2.05761C30.4649 2.05761 33.0156 4.5147 33.0156 7.55011H26.823C26.3479 7.59079 25.9853 7.72659 25.9853 8.39996V13.173C23.2042 12.5756 21.615 10.2706 21.615 7.55011C21.615 4.5147 24.1657 2.05761 27.3153 2.05761Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5025 7.55007C31.7012 8.02792 31.8076 8.54921 31.8076 9.095C31.8076 11.4461 29.7866 13.3548 27.2935 13.3548C26.8387 13.3548 26.3981 13.2897 25.9836 13.1729",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7018 18.041L35.3153 19.7188C35.0505 19.9414 35.3499 22.2112 35.5284 22.1379H39.8698H41.79V18.4021C41.79 17.6663 41.3841 17.8292 40.7018 18.041Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8045 22.1379H33.2564H35.528C36.9905 22.1379 37.0336 19.8518 35.3149 19.7189L32.8045 19.5287L32.1308 20.8727L32.8045 22.1379Z",
    fill: "#FFECE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9364 17.4274L27.0352 16.697C24.7782 14.8644 21.9251 17.9567 24.9423 19.8029L27.4815 21.356L28.7598 22.1379H32.8047V19.5288L30.2913 19.336L27.9364 17.4274Z",
    fill: "#FF8086"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8047 22.1379V20.8727H33.343H33.6338H34.0887H36.3602C36.4465 20.8727 36.5271 20.8673 36.6048 20.8511C36.6883 21.4809 36.3112 22.1379 35.5282 22.1379H33.2566H32.8047Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9423 19.803C23.117 18.6844 23.4395 17.1125 24.4788 16.45C24.3953 17.1287 24.7379 17.9079 25.7742 18.5406L27.7522 19.7487L28.3106 20.0935L29.5889 20.8727H32.8047V22.1378H28.7598L27.4815 21.356L24.9423 19.803Z",
    fill: "#F76672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3153 19.7189L37.4832 19.0455C38.2086 19.7786 38.5598 21.2067 38.0935 22.1378H36.0638H35.5284C36.3114 22.1378 36.6885 21.4808 36.6051 20.851C36.5302 20.3053 36.1128 19.7813 35.3153 19.7189Z",
    fill: "#FFC269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.035 16.697L30.2911 19.336L32.7959 19.5261L35.3149 19.7188C37.0337 19.8519 36.9904 22.1379 35.528 22.1379H28.7595L24.9421 19.803C21.9249 17.9568 24.7779 14.8644 27.035 16.697Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5283 22.1379H41.79V18.4021C41.79 17.6663 41.3841 17.8292 40.7017 18.0409L35.3152 19.7189C37.034 19.8518 36.9908 22.1379 35.5283 22.1379Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7959 22.1379V19.5261",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1952 31.8659H8.61208C7.92978 31.8659 7.36844 31.3391 7.36844 30.6929V28.0024H18.7949M26.3838 31.8659H19.6097",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6614 46.2826C48.3907 45.6907 50.0921 43.1251 49.4645 40.5539L39.5869 42.6961C40.2144 45.2672 42.9351 46.8746 45.6614 46.2826Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5419 27.5843L39.8693 22.1379H36.0634C39.3309 30.674 37.425 36.0199 34.7649 41.7078H37.6352M43.8105 35.0452L42.5236 30.8559",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8509 35.1592C47.251 34.8388 50.4524 36.9457 51.2383 40.1684L38.0412 43.03C37.903 43.0599 37.8195 43.1087 37.7908 42.9893C37.6929 42.5603 37.6439 42.1314 37.6381 41.705L43.8509 35.1592Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2076 41.7078L34.7656 41.7051M8.61318 31.8659C7.57115 33.5763 6.73336 35.6316 7.45587 39.563",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6642 34.494C18.8301 34.494 22.207 37.6923 22.207 41.7078H7.56466C7.30558 41.7078 7.11555 41.7404 7.12419 41.4797C7.24799 37.5728 10.5761 34.494 14.6642 34.494Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3096 41.7078C20.1455 44.6238 17.6379 46.9424 14.5691 46.9424C11.5 46.9424 8.99246 44.6238 8.82833 41.7078H20.3096Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3575 38.4416H36.1846",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6973 35.2922V30.8586C30.6973 26.6286 28.3567 25.2629 26.4537 25.0674H18.1912C18.0327 28.0024 19.2275 29.3084 22.2763 29.311L25.0113 29.3137C26.3846 29.3137 26.3846 30.1744 26.3846 31.8658V35.2922",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 38.4416C33.4805 35.8733 31.8309 35.2922 30.6966 35.2922H26.3839V37.8525C26.3839 38.4009 26.7006 38.4416 27.167 38.4416H33.3567Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliver);
export default __webpack_public_path__ + "static/media/Deliver.77d1f4da290db34086a4c4dd9278bca2.svg";
export { ForwardRef as ReactComponent };